export default __webpack_public_path__ + "6c01e67df7ac929413e8d87be984cac6.png";